import { FC, ReactNode } from 'react'
import CloseIcon from '../../assets/images/close_rg.svg'
import './styles.css'

interface BaseModalProps {
  isOpen: boolean
  title?: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
}

const BaseModal: FC<BaseModalProps> = ({ isOpen, title, onClose, children, footer }) => {
  if (!isOpen) return null

  return (
    <div className="overlay">
      <div className="modal-container">
        <div className="modal-title-container">
          {title && <h2 className="modal-title">{title}</h2>}
          <button className="modal-close-button" onClick={onClose}>
            <img src={CloseIcon} alt="close" style={{ width: 24 }} />
          </button>
        </div>

        <div className="modal-content">{children}</div>

        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  )
}

export default BaseModal
